import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/revisoes/RevisoesApiClient'

export default {
	async [actionTypes.CONFIGURACAO.REVISOES.BUSCAR_REVISOES]({ state }) {
		const { paginacao, filtro } = state
		const { data } = await api.buscarRevisoes(paginacao, filtro)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.EXCLUIR_REVISAO](context, idRevisao) {
		await api.excluirRevisao(idRevisao)
	},

	async [actionTypes.CONFIGURACAO.REVISOES.INSERIR_REVISAO](context, objParam) {
		const { data } = await api.inserirRevisao(objParam)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.BUSCAR_REVISAO_POR_ID](context, idRevisao) {
		const { data } = await api.buscarRevisaoPorId(idRevisao)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.EDITAR_REVISAO](context, { idRevisao, body }) {
		const { data } = await api.editarRevisao(idRevisao, body)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.ALTERAR_SITUACAO_REVISAO](context, { idRevisao, body }) {
		const { data } = await api.alterarSituacao(idRevisao, body)
		return data
	},
}
